import { DOWNLOAD_SERVICE_IS_ACTIVE } from './download-certificates-actions';


const defaultState = {
    isActive: false,
    downloadType: null
};

/**
 * Download Certificates Reducer
 *
 * Consumes DOWNLOAD_SERVICE_IS_ACTIVE action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case DOWNLOAD_SERVICE_IS_ACTIVE: {
        const { isActive, downloadType } = action.payload;
        return { isActive, downloadType };
    }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/certificates/download-certificates-reducer.js